'use client';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';

interface HeaderSubMenuItemProps {
    text: string;
    variant?: 'dark' | 'light';
    className?: string;
}

const HeaderSubMenuItem = ({
    text,
    variant = 'dark',
    className = ''
}: HeaderSubMenuItemProps) => {
    const [isOpen, setIsOpen] = useState(false)

    const baseClasses = 'text-sm font-semibold leading-sm hover:opacity-80 transition-opacity duration-200'
    const variantClasses = variant === 'light' ? 'text-text-on-dark' : 'text-text-primary'

    return (
        <div className="relative z-50">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className={twMerge(
                    'flex flex-row items-center gap-1.5',
                    baseClasses,
                    variantClasses,
                    className
                )}
                aria-haspopup="true"
                aria-expanded={isOpen}
            >
                <span>{text}</span>
                <img
                    src="/images/img_arrow_down.svg"
                    alt=""
                    className={`w-2.5 h-2.5 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
                />
            </button>

            {isOpen && (
                <ul
                    className="absolute top-full right-0 mt-2 bg-background-main border border-border-light rounded-lg shadow-lg py-2 min-w-[150px] z-[100]"
                    role="menu"
                >
                    <li role="menuitem">
                        <button className="w-full text-left px-4 py-2 text-sm text-text-primary hover:bg-background-secondary transition-colors duration-200">
                            English / USD
                        </button>
                    </li>
                    <li role="menuitem">
                        <button className="w-full text-left px-4 py-2 text-sm text-text-primary hover:bg-background-secondary transition-colors duration-200">
                            Spanish / EUR
                        </button>
                    </li>
                    <li role="menuitem">
                        <button className="w-full text-left px-4 py-2 text-sm text-text-primary hover:bg-background-secondary transition-colors duration-200">
                            French / EUR
                        </button>
                    </li>
                </ul>
            )}
        </div>
    )
}

export default HeaderSubMenuItem